import { render, staticRenderFns } from "./PackLists.vue?vue&type=template&id=5c49fa6c"
import script from "./PackLists.vue?vue&type=script&lang=js"
export * from "./PackLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports